import CategorySlug from './CategorySlug';
import UnitType from './UnitType';

export default {
	[UnitType.ROOM]: CategorySlug.PLACE,
	[UnitType.PRODUCT]: CategorySlug.PRODUCT_PLACE,
	[UnitType.CONSULT]: CategorySlug.CONSULT_PLACE,
};
